import z from 'zod';

export type CarbonDioxideDto = {
	originLocationId: string;
	origin: string;
	productionMethodId: string;
	productionMethod: string;
	value: number;
	source: string | null;
};

export const CarbonDioxideDtoSchema: z.ZodType<CarbonDioxideDto> = z.object({
	originLocationId: z.string(),
	origin: z.string(),
	productionMethodId: z.string(),
	productionMethod: z.string(),
	value: z.number(),
	source: z.string().nullable(),
});
